import { render, staticRenderFns } from "./zhpt.vue?vue&type=template&id=499812a6&scoped=true"
import script from "./zhpt.vue?vue&type=script&lang=js"
export * from "./zhpt.vue?vue&type=script&lang=js"
import style0 from "./zhpt.vue?vue&type=style&index=0&id=499812a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499812a6",
  null
  
)

export default component.exports